import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ButtonToolbar, Content, Panel, Icon, Button } from 'rsuite';
import PageLayout from '../../../components/reservations/PageLayout';
import PageHeader from '../../../components/PageHeader';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import ReservationSearch from '../../../containers/reservations/Search/Archived';
import ArchivedReservationList from '../../../containers/reservations/ArchivedList';
import PrintReservations from '../../../components/reservations/PrintReservations';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import {
  getOrder,
  getItemForBarcode
} from '../../../redux/Reservation/selectors/archived';
import {
  getCurrentPageItems,
  getPaginationQueryOptions
} from '../../../redux/Reservation/selectors/archived/pagination';
import SearchContext from '../../../constants/reservation/SearchContext';
import ExportButton from '../../../components/reservations/ExportButton';
import RememberListCheckbox from '../../../components/reservations/RememberListCheckbox';
import * as PERMISSIONS from '../../../constants/permissions/reservation';
import orderList from '../../../helpers/reservationOrderList';
import { modifyAccess } from '../../../helpers/permission';
import pagePathToUrl from '../../../helpers/pagePathToUrl';
import mergeListQueries from '../../../helpers/mergeListQueries';
import exportReservationsAsCsv from '../../../helpers/exportReservationsAsCsv';
import { EXPORT_ARCHIVED } from '../../../constants/reservation/ExportTypes';
import { reservationsCreatePath, reservationsViewPath } from '../../Paths';
import history from '../../history';

export default () => {
  const context = SearchContext.ARCHIVED;
  const [isExporing, setIsExporting] = useState(false);
  const paginationQuery = useSelector(getPaginationQueryOptions);
  const searchQuery = useSelector(state =>
    getSearchQueryForContext(state, context)
  );
  const order = useSelector(getOrder);
  const query = mergeListQueries(paginationQuery, searchQuery, order);
  const { code = '' } = searchQuery;
  const reservation = useSelector(state => getItemForBarcode(state, code));
  const reservations = useSelector(getCurrentPageItems);
  const orderedReservations = orderList(order, reservations);

  useEffect(
    () => {
      if (code && reservation) {
        history.push(
          pagePathToUrl(reservationsViewPath, { id: reservation.id })
        );
      }
    },
    [code, reservation]
  );

  const handleExport = async () => {
    setIsExporting(true);
    await exportReservationsAsCsv(EXPORT_ARCHIVED, { ...searchQuery, order });
    setIsExporting(false);
  };

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={modifyAccess(PERMISSIONS.MODULE)}
        fallback={<AccessDenied />}
      >
        <PageHeader title="Archived Reservation">
          <Panel bordered>
            <ButtonToolbar style={{ float: 'right' }}>
              <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.MODULE)}>
                <Link to={reservationsCreatePath}>
                  <Button appearance="primary">
                    <Icon icon="plus-circle" /> Create New
                  </Button>
                </Link>
              </AccessControl>
            </ButtonToolbar>
            <ReservationSearch
              withRequestTime
              withStatus
              exportButton={
                <ExportButton
                  onClick={handleExport}
                  isLoading={isExporing}
                  style={{ marginRight: 10 }}
                />
              }
              printButton={
                <PrintReservations
                  fileName="archived-reservations"
                  data={orderedReservations}
                />
              }
              showHiddenHelpDesired
            />
          </Panel>
        </PageHeader>
        <Content>
          <RememberListCheckbox context={context} query={query} />
          <ArchivedReservationList actions={['create']} showNotes />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
